import {
  ProductPriceInfo,
  productPriceInfoFromResponse,
} from '../Product/ProductPriceInfo';
import { BasketProduct, basketProductFromResponse } from './BasketProduct';
import { BasketOption, basketOptionFromResponse } from './BasketOption';

export interface BasketItem {
  id: number;
  quantity: number;
  productID: number;
  price: ProductPriceInfo;
  total: ProductPriceInfo;
  product: BasketProduct;
  options: BasketOption[];
}

export const basketItemFromResponse = (responseData: any): BasketItem => ({
  id: responseData.id,
  quantity: responseData.quantity,
  productID: responseData.product_id,
  price: productPriceInfoFromResponse(responseData.price),
  total: productPriceInfoFromResponse(responseData.total),
  product: basketProductFromResponse(responseData.product),
  options: (responseData.options ?? []).map(basketOptionFromResponse),
});
